module.exports = __webpack_public_path__ + "14ff0434ec628b880e5c205fe2ae010b.png";